__turbopack_context__.v({
  "className": "ortornids_79b1310c-module__XpZxSa__className",
  "variable": "ortornids_79b1310c-module__XpZxSa__variable",
});
